//import * as config from  'public/config.json'
const config = window.globalTS;
//const  config = require('public/config.json');
export const CLIENT_DATE_FORMAT = `dd/MM/yyyy`;
export const SERVER_DATE_FORMAT = 'yyyy-MM-DD';
export const SERVER_YYYYMM_FORMAT = `yyyy/MM`;
export const PATH_RANK = 2;

export const BASE_API =  config.BASE_API;//`http://www.fcv-etools.com:81/api/`; //deploy
//export const BASE_API = `https://localhost:44348/api/`;// dev
//export  const image_root =  `http://fcv-etools.com:82/`;// dev;
export  const image_root =  config.image_root //process.env.PUBLIC_URL;// deploy;
export  const root_path =  config.root_path //process.env.PUBLIC_URL;// deploy;
export  const display_url =  config.display_url //process.env.PUBLIC_URL;// deploy;
export  const isTEST =  config.TEST //process.env.PUBLIC_URL;// deploy;
export  const template_upload_root =    config.image_root+'/template/';// dev;

export const LOGIN_METHOD = `Login`;
export const verify_token_METHOD = `verify_token`;
export const NPP_ROLE = `nhanvien/npp_role`;
export const DASHBOARD_METHOD = 'dashboard';
export const STATUS_METHOD = `trangthai/`;
export const LEFTMENU_METHOD = `menu/`;
export const MAIN_METHOD = `Main/`;
export const coquan_METHOD = `Coquan/`;
export const capcoquan_METHOD = `Capcoquan/`;
export const nhomsukien_METHOD = `Nhomsukien/`;
export const phanloaisukien_METHOD = `Phanloaisukien/`;
export const loaiphansucap1_METHOD = `Loaiphansucap1/`;
export const loaiphansucap2_METHOD = `Loaiphansucap2/`;
export const nhomphansu_METHOD = `Nhomphansu/`;
export const bieumautailieu_METHOD = `Bieumautailieu/`;
export const thanhgiao_METHOD = `Thanhgiao/`;

export const loaithongbao_METHOD = `Loaithongbao/`;
export const hinhthuc_METHOD = `Hinhthuc/`;
export const loaibieumautailieu_METHOD = `Loaibieumautailieu/`;
export const phansu_METHOD = `Phansu/`;
export const nhadan_METHOD = `Nhadan/`;
export const THONGBAOS_METHOD = `thongbao/`;
export const HOPTHUS_METHOD = `hopthu/`;
export const BAOCAO_METHOD = `baocao/`;
export const PHANQUYENS_METHOD = `Phanquyen/`;
export const PHANQUYENAPPS_METHOD = `Phanquyenapp/`;
export const USER_METHOD = `User/`;
export const DAOHUU_METHOD = `Daohuu/`;
export const SUKIEN_METHOD = `Sukien/`;
export const THONGBAO_METHOD = `Thongbao/`;
export const NHANVIENS_METHOD = `Nhanvien/`;
export const TINHTHANHS_METHOD = `tinhthanh/`;
export const QUANHUYENS_METHOD = `quanhuyen/`;
export const PHUONGXAS_METHOD = `phuongxa/`;
export const INIT_ROLE_MENU = {
	quyenchot: 1,
	quyentaomoi: 1,
	quyenbaocao: 1,
	quyenxoa: 1,
	quyenhienthi: 1,
	quyenmochot: 1,
	quyenin: 1,
	quyenchinhsua: 1,
	tenmenu: 'Khong xac dinh'
};
export const INIT_RESULT_MSG = {
	status: false,
	msg: `Không thể kết nối server`,
	data: [],
};
export const PAGES_SIZE_DEFAULT = [10,20,50,100];

export const pageStyleToPrint = `
	@media all {
		.page-break {
			display: none;
		}
	}
	@media print {
		html, body {
			height: initial !important;
			overflow: initial !important;
			-webkit-print-color-adjust: exact;
			padding: 40px 30px;
		}
	}
	@media print {
		.page-break {
			margin-top: 1rem;
			display: block;
			page-break-before: auto;
		}
	}
	@page {
		size: auto !important;
		margin: 0mm;
	}
`;

export const pageStyleA4ToPrint = `
	@media all {
		.page-break {
			display: none;
		}
	}
	@media print {
		html, body {
			height: initial !important;
			overflow: initial !important;
			-webkit-print-color-adjust: exact;
			padding: 10px 20px 10px 10px;
		}
	}
	@media print {
		.page-break {
			// margin-top: 1rem;
			display: block;
			page-break-before: auto;
		}
	}
	@page {
		size: A4 !important;
		margin: 0mm;
	}
`;

export const initial_image_arr = [
	{
		imageNo :1,
		ImagePath:'',
		latGPS: null,
		longGPS: null,
		timesTamp:  null
	},
	{
		imageNo :2,
		ImagePath:'',
		latGPS: null,
		longGPS: null,
		timesTamp:  null
	},
	{
		imageNo :3,
		ImagePath:'',
		latGPS: null,
		longGPS: null,
		timesTamp:  null
	},
	{
		imageNo :4,
		ImagePath:'',
		latGPS: null,
		longGPS: null,
		timesTamp:  null
	},
	{
		ImageNo :5,
		ImagePath:'',
		latGPS: null,
		longGPS: null,
		timesTamp:  null
	},
	{
		ImageNo :6,
		ImagePath:'',
		latGPS: null,
		longGPS: null,
		timesTamp:  null
	},
	{
		ImageNo :7,
		ImagePath:'',
		latGPS: null,
		longGPS: null,
		timesTamp:  null
	},
	{
		ImageNo :8,
		ImagePath:'',
		latGPS: null,
		longGPS: null,
		timesTamp:  null
	},
	{
		ImageNo :9,
		ImagePath:'',
		latGPS: null,
		longGPS: null,
		timesTamp:  null
	},
	{
		ImageNo :10,
		ImagePath:'',
		latGPS: null,
		longGPS: null,
		timesTamp:  null
	}

]